import React from 'react'
import { useNavigate } from 'react-router-dom'
import { IOperationPlan, PLAN_STATUS_COLORS } from '../types/operations.types'
import {
  PlanCardStyled,
  PlanCardTop,
  PlanName,
  PlanMeta,
  PlanStats,
  PlanStat,
  ProgressBarWrapper,
  ProgressBarFill,
  Badge,
  opsColors,
} from '../styled/Operations.styled'
import { QueueHealthBadge } from './QueueHealthBadge'

interface PlanCardProps {
  plan: IOperationPlan
}

export const PlanCard: React.FC<PlanCardProps> = ({ plan }) => {
  const navigate = useNavigate()
  const isAtRisk = plan.queueHealth === 'At Risk'

  return (
    <PlanCardStyled
      atRisk={isAtRisk}
      onClick={() => navigate(`/ops-control/plans/${plan.id}`)}
    >
      <PlanCardTop>
        <div>
          <PlanName>{plan.name}</PlanName>
          <PlanMeta>{plan.siteName} &middot; {plan.departmentName}</PlanMeta>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <QueueHealthBadge health={plan.queueHealth} />
          <Badge bg={PLAN_STATUS_COLORS[plan.status]}>{plan.status}</Badge>
        </div>
      </PlanCardTop>

      <ProgressBarWrapper>
        <ProgressBarFill
          percent={plan.progress}
          color={isAtRisk ? opsColors.warningBase : opsColors.brand500}
        />
      </ProgressBarWrapper>

      <PlanStats>
        <PlanStat>
          <span className="stat-value">{plan.currentValue}/{plan.targetValue} {plan.targetUnit}</span>
          <span className="stat-label">Throughput</span>
        </PlanStat>
        <PlanStat>
          <span className="stat-value">{plan.workers}</span>
          <span className="stat-label">Workers</span>
        </PlanStat>
        <PlanStat>
          <span className="stat-value">{plan.machines}</span>
          <span className="stat-label">Machines</span>
        </PlanStat>
        <PlanStat>
          <span className="stat-value">{plan.activeCycles}</span>
          <span className="stat-label">Active Cycles</span>
        </PlanStat>
        <PlanStat>
          <span className="stat-value">{plan.progress}%</span>
          <span className="stat-label">Progress</span>
        </PlanStat>
        {plan.estCompletion && (
          <PlanStat>
            <span className="stat-value">{new Date(plan.estCompletion).toLocaleDateString()}</span>
            <span className="stat-label">Est. Completion</span>
          </PlanStat>
        )}
      </PlanStats>
    </PlanCardStyled>
  )
}
